<div class="p-8 h-full flex items-center justify-center">
  <div class="max-w-md w-full">
    <div class="bg-white rounded-xl border border-slate-200 p-8 text-center shadow-sm">
      <div class="inline-flex items-center justify-center w-20 h-20 bg-red-50 rounded-2xl mb-6">
        <i class="bi bi-lock text-red-500 text-4xl"></i>
      </div>
      <h1 class="text-slate-900 font-semibold text-lg mb-2">{{ titulo() }}</h1>
      <p class="text-slate-600 mb-6">{{ mensaje() }}</p>
      <button
        class="w-full flex items-center justify-center gap-2 px-6 py-3 bg-accent-600 text-white rounded-lg hover:bg-accent-500 transition-colors font-medium shadow-sm"
        (click)="onDesbloquear()"
      >
        <i class="bi bi-unlock text-white text-lg"></i>
        {{ botonTexto() }}
      </button>
    </div>
  </div>
</div>
